import * as yup from "yup";
import constantes from "../../catalogos/constantes";

const guardar = yup.object().shape({
    datosGenerales: yup.object().shape({
        esMotriz: yup.boolean().default(false),
        esPermisionario: yup.boolean().default(false),

        numeroEconomico: yup
            .string()
            .required("El número económico es obligatorio"),

        tipoEquipo: yup
            .object({
                id: yup
                    .number()
                    .required("El tipo de equipo es obligatorio")
                    .min(1, "El tipo de equipo es obligatorio"),
            })
            .required("El tipo de equipo es obligatorio"),

        tipoUnidad: yup
            .object({
                id: yup
                    .number()
                    .required("El tipo de unidad es obligatorio")
                    .min(1, "El tipo de unidad es obligatorio"),
            })
            .required("El tipo de unidad es obligatorio"),

        marcaArrastre: yup.mixed().when("esMotriz", {
            is: false,
            then: (schema) =>
                schema
                    .required("La marca es obligatoria")
                    .test(
                        "marca-arrastre-valida",
                        "Selecciona una marca válida",
                        (value) => value?.id > 0
                    ),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),

        marcaMotriz: yup.mixed().when("esMotriz", {
            is: true,
            then: (schema) =>
                schema
                    .required("La marca es obligatoria")
                    .test(
                        "marca-motriz-valida",
                        "Selecciona una marca válida",
                        (value) => value?.id > 0
                    ),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),

        modelo: yup
            .number()
            .typeError("El año debe ser numérico")
            .required("El año es obligatorio"),

        tarjetaCirculacion: yup
            .mixed()
            .required("La tarjeta de circulación es obligatoria"),

        carroceria: yup.mixed().when("esPermisionario", {
            is: true,
            then: (schema) =>
                schema
                    .required("El modelo es obligatorio")
                    .test(
                        "carroceria-valida",
                        "Selecciona un modelo válido",
                        (value) => value?.id > 0
                    ),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),

        permisionarioId: yup
            .number()
            .transform((value, originalValue) => {
                if (
                    originalValue === "" ||
                    originalValue === undefined ||
                    originalValue === null
                ) {
                    return null;
                }

                const numero = Number(originalValue);
                return Number.isNaN(numero) ? null : numero;
            })
            .nullable()
            .when("esPermisionario", {
                is: true,
                then: (schema) =>
                    schema
                        .required("El permisionario es obligatorio")
                        .typeError("El permisionario es obligatorio"),
                otherwise: (schema) => schema.notRequired(),
            }),
    }),
});

const alta = yup.object().shape({
    datosGenerales: yup.object().shape({
        esMotriz: yup.boolean().default(false),
        esPermisionario: yup.boolean().default(false),

        numeroEconomico: yup
            .string()
            .required("El número económico es obligatorio"),

        tipoEquipo: yup
            .object({
                id: yup
                    .number()
                    .required("El tipo de equipo es obligatorio")
                    .min(1, "El tipo de equipo es obligatorio"),
            })
            .required("El tipo de equipo es obligatorio"),

        tipoUnidad: yup
            .object({
                id: yup
                    .number()
                    .required("El tipo de unidad es obligatorio")
                    .min(1, "El tipo de unidad es obligatorio"),
            })
            .required("El tipo de unidad es obligatorio"),

        marcaArrastre: yup.mixed().when("esMotriz", {
            is: false,
            then: (schema) =>
                schema
                    .required("La marca es obligatoria")
                    .test(
                        "marca-arrastre-valida",
                        "Selecciona una marca válida",
                        (value) => value?.id > 0
                    ),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),

        marcaMotriz: yup.mixed().when("esMotriz", {
            is: true,
            then: (schema) =>
                schema
                    .required("La marca es obligatoria")
                    .test(
                        "marca-motriz-valida",
                        "Selecciona una marca válida",
                        (value) => value?.id > 0
                    ),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),

        modelo: yup
            .number()
            .typeError("El año debe ser numérico")
            .required("El año es obligatorio"),

        placas: yup
            .string()
            .required("Las placas son obligatorias"),

        numeroSerie: yup
            .string()
            .required("El número de serie es obligatorio"),

        tarjetaCirculacion: yup
            .mixed()
            .required("La tarjeta de circulación es obligatoria"),

        nacionalCruce: yup
            .object({
                id: yup
                    .number()
                    .required("Selecciona Nacional o Cruce")
                    .min(1, "Selecciona Nacional o Cruce"),
            })
            .required("Selecciona Nacional o Cruce"),

        proveedorGPS: yup
            .object({
                id: yup
                    .number()
                    .required("El proveedor GPS es obligatorio")
                    .min(1, "El proveedor GPS es obligatorio"),
            })
            .required("El proveedor GPS es obligatorio"),

        polizaSeguro: yup
            .mixed()
            .when(["tipoEquipo.id", "esPermisionario"], {
                is: (tipoEquipoId, esPermisionario) =>
                    tipoEquipoId === constantes.tiposEquipo.motriz &&
                    esPermisionario === true,

                then: (schema) =>
                    schema.required("La póliza de seguro es obligatoria"),

                otherwise: (schema) => schema.notRequired(),
            }),

        incisoPoliza: yup
            .mixed()
            .when(["tipoEquipo.id", "esPermisionario"], {
                is: (tipoEquipoId, esPermisionario) =>
                    tipoEquipoId === constantes.tiposEquipo.motriz &&
                    esPermisionario === true,

                then: (schema) =>
                    schema.required("El inciso de póliza es obligatorio"),

                otherwise: (schema) => schema.notRequired(),
            }),

        agenteSeguro: yup
            .mixed()
            .when(["tipoEquipo.id", "esPermisionario"], {
                is: (tipoEquipoId, esPermisionario) =>
                    tipoEquipoId === constantes.tiposEquipo.motriz &&
                    esPermisionario === true,

                then: (schema) =>
                    schema.required("El agente de seguro es obligatorio"),

                otherwise: (schema) => schema.notRequired(),
            }),

        telefonoAseguradora: yup
            .mixed()
            .when(["tipoEquipo.id", "esPermisionario"], {
                is: (tipoEquipoId, esPermisionario) =>
                    tipoEquipoId === constantes.tiposEquipo.motriz &&
                    esPermisionario === true,

                then: (schema) =>
                    schema.required(
                        "El teléfono de la aseguradora es obligatorio"
                    ),

                otherwise: (schema) => schema.notRequired(),
            }),

        aseguradora: yup
            .mixed()
            .when(["tipoEquipo.id", "esPermisionario"], {
                is: (tipoEquipoId, esPermisionario) =>
                    tipoEquipoId === constantes.tiposEquipo.motriz &&
                    esPermisionario === true,

                then: (schema) =>
                    schema
                        .required("La aseguradora es obligatoria")
                        .test(
                            "aseguradora-valida",
                            "Selecciona una aseguradora válida",
                            (value) => value?.id > 0
                        ),

                otherwise: (schema) => schema.nullable().notRequired(),
            }),

        carroceria: yup.mixed().when("esPermisionario", {
            is: true,
            then: (schema) =>
                schema
                    .required("El modelo es obligatorio")
                    .test(
                        "carroceria-valida",
                        "Selecciona un modelo válido",
                        (value) => value?.id > 0
                    ),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),

        permisionarioId: yup
            .number()
            .transform((value, originalValue) => {
                if (
                    originalValue === "" ||
                    originalValue === undefined ||
                    originalValue === null
                ) {
                    return null;
                }

                const numero = Number(originalValue);
                return Number.isNaN(numero) ? null : numero;
            })
            .nullable()
            .when("esPermisionario", {
                is: true,
                then: (schema) =>
                    schema
                        .required("El permisionario es obligatorio")
                        .typeError("El permisionario es obligatorio"),
                otherwise: (schema) => schema.notRequired(),
            }),
    }),

    especificaciones: yup.mixed().when("datosGenerales.esMotriz", {
        is: true,
        then: () =>
            yup.object().shape({
                capacidadTanque: yup
                    .number()
                    .typeError("La capacidad del tanque debe ser numérica")
                    .required("La capacidad del tanque es obligatoria"),

                odometroInicial: yup
                    .number()
                    .typeError("El odómetro inicial debe ser numérico")
                    .required("El odómetro inicial es obligatorio"),

                marcaMotor: yup
                    .object({
                        id: yup
                            .number()
                            .required("La marca del motor es obligatoria")
                            .min(1, "La marca del motor es obligatoria"),
                    })
                    .required("La marca del motor es obligatoria"),

                numeroMotor: yup
                    .string()
                    .required("El número de motor es obligatorio"),

                softwareEscaner: yup
                    .object({
                        id: yup
                            .number()
                            .required("El software de escáner es obligatorio")
                            .min(1, "El software de escáner es obligatorio"),
                    })
                    .required("El software de escáner es obligatorio"),

                tarjetasCruce: yup.array().of(
                    yup.object().shape({
                        numero: yup.mixed().when("requerido", {
                            is: true,
                            then: (schema) =>
                                schema.required(
                                    "El número de tarjeta es obligatorio"
                                ),
                            otherwise: (schema) => schema.notRequired(),
                        }),
                    })
                ),

                tipoCombustible: yup.array().of(
                    yup.object().shape({
                        nombre: yup
                            .string()
                            .required("El combustible es obligatorio"),
                    })
                ),
            }),

        otherwise: (schema) => schema.notRequired(),
    }),

    documentacion: yup.array().of(
        yup.object().shape({
            vigencia: yup
                .mixed()
                .when("tipoDocumento.vigenciaRequerida", {
                    is: true,
                    then: (schema) =>
                        schema.required(
                            "La fecha de vencimiento es obligatoria"
                        ),
                    otherwise: (schema) => schema.notRequired(),
                }),

            archivo: yup.mixed().when("tipoDocumento.requerido", {
                is: true,
                then: () =>
                    yup
                        .object({
                            isEmpty: yup
                                .boolean()
                                .required("El archivo es obligatorio")
                                .oneOf([false], "El archivo es obligatorio"),
                        })
                        .required("El archivo es obligatorio"),

                otherwise: (schema) => schema.notRequired(),
            }),
        })
    ),

    expediente: yup.array().of(
        yup.object().shape({
            archivo: yup.mixed().when("tipoDocumento.requerido", {
                is: true,
                then: () =>
                    yup
                        .object({
                            isEmpty: yup
                                .boolean()
                                .required("El archivo es obligatorio")
                                .oneOf([false], "El archivo es obligatorio"),
                        })
                        .required("El archivo es obligatorio"),

                otherwise: (schema) => schema.notRequired(),
            }),
        })
    ),

    accesorios: yup.array().of(
        yup.object().shape({
            nombre: yup
                .string()
                .required("El nombre del accesorio es obligatorio"),
        })
    ),
});

const unidadValidacionEsquema = {
    alta,
    guardar,
};

export default unidadValidacionEsquema;